import styled from "styled-components";
import { Medal } from "./Medal";
import {
  Category,
  Date,
  Header,
  MedalWrapper,
  Result,
  Tier,
  Title,
} from "./SportTile.styles";

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;

  display: flex;
  justify-content: center;
  align-items: center;
`;

const Container = styled.div`
  background-color: white;
  border-radius: 8px;
  border: 1px solid black;
  padding: 15px;
  display: flex;
  flex-direction: column;

  @media only screen and (min-width: 600px) {
    flex-direction: row;
  }
`;

const Metadata = styled.div`
  @media only screen and (min-width: 600px) {
    width: 200px;
    padding: 0 10px;
  }
`;
const TileFullImageContainer = styled.div``;

const GraphModal = ({
  onClickOut,
  sport,
  full,
  category,
  tier,
  date,
  result,
  medals,
}) => {
  return (
    <Overlay onClick={onClickOut}>
      <Container onClick={(e) => e.stopPropagation()}>
        <TileFullImageContainer>
          <img src={full} alt={`${sport} graph`} />
        </TileFullImageContainer>

       {/*
        <Metadata>
          <Header>
            <Title>{sport}</Title>
            <Category>{category}</Category>
          </Header>
          <Tier>{tier}</Tier>
          <Date>{date}</Date>
          <Result>
            {result &&
              result
                .split("\n")
                .map((resultLine) => <div key={resultLine}>{resultLine}</div>)}
          </Result>
          <MedalWrapper>
            {medals &&
              Object.keys(medals).map((cls) => (
                <Medal key={medals[cls]} medalClass={cls} label={medals[cls]} />
              ))}
          </MedalWrapper>
        </Metadata>
              */}
        
      </Container>
    </Overlay>
  );
};

export default GraphModal;
